export const NAME_COL_WIDTH = 280
export const ID_COL_WIDTH = 140
